var _rect, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBusinessInfo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 49,
    viewBox: "0 0 49 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.526306,
    y: 0.342285,
    width: 48.1316,
    height: 48.1316,
    rx: 5,
    className: "outer"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.2487 24.5093H11.335C10.7721 24.5093 10.3158 24.964 10.3158 25.5249V35.3232C10.3158 35.8841 10.7721 36.3388 11.335 36.3388H17.2487C17.8116 36.3388 18.2679 35.8841 18.2679 35.3232V25.5249C18.2679 24.964 17.8116 24.5093 17.2487 24.5093Z",
    className: "inner"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.5112 17.1777H21.5975C21.0346 17.1777 20.5783 17.6325 20.5783 18.1934V35.325C20.5783 35.8859 21.0346 36.3406 21.5975 36.3406H27.5112C28.0741 36.3406 28.5305 35.8859 28.5305 35.325V18.1934C28.5305 17.6325 28.0741 17.1777 27.5112 17.1777Z",
    className: "inner"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.8475 8.5H31.9338C31.3709 8.5 30.9146 8.95473 30.9146 9.51566V35.3249C30.9146 35.8858 31.3709 36.3406 31.9338 36.3406H37.8475C38.4104 36.3406 38.8667 35.8858 38.8667 35.3249V9.51566C38.8667 8.95473 38.4104 8.5 37.8475 8.5Z",
    className: "inner"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.2386 37.7812H10.9456C10.5978 37.7812 10.3158 38.0622 10.3158 38.4088V39.6884C10.3158 40.035 10.5978 40.316 10.9456 40.316H38.2386C38.5865 40.316 38.8684 40.035 38.8684 39.6884V38.4088C38.8684 38.0622 38.5865 37.7812 38.2386 37.7812Z",
    className: "inner"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28.5526,
    height: 31.8158,
    transform: "translate(10.3158 8.5)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBusinessInfo);
export default __webpack_public_path__ + "static/media/business-info.9ab051e6.svg";
export { ForwardRef as ReactComponent };